/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingstatusprocessing2Inputs */

const en_crosspostingstatusprocessing2 = /** @type {(inputs: Crosspostingstatusprocessing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing…`)
};

const de_crosspostingstatusprocessing2 = /** @type {(inputs: Crosspostingstatusprocessing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird veröffentlicht…`)
};

/**
* | output |
* | --- |
* | "Publishing…" |
*
* @param {Crosspostingstatusprocessing2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingstatusprocessing2 = /** @type {((inputs?: Crosspostingstatusprocessing2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingstatusprocessing2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingstatusprocessing2(inputs)
	return de_crosspostingstatusprocessing2(inputs)
});
export { crosspostingstatusprocessing2 as "crosspostingStatusProcessing" }